import {
  MicrosoftIcon
} from "./chunk-U5F6Z7AI.mjs";
export {
  MicrosoftIcon
};
